import { render, staticRenderFns } from "./AllInBox.vue?vue&type=template&id=57b6a654&"
import script from "./AllInBox.vue?vue&type=script&lang=js&"
export * from "./AllInBox.vue?vue&type=script&lang=js&"
import style0 from "./AllInBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports